import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

export const loaderInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const apisToBeSkipped: string[] = ['partner-availability', 'filters', 'driver-map-ride', 'server-timezone', 'avatar', 'statistics', 'equipment-files'];
  const loaderService = inject(LoaderService);

  if (apisToBeSkipped.every(a => !req.url.includes(a))) {
    loaderService.show();
  }

  return next(req).pipe(
    catchError(error => {
      if (apisToBeSkipped.every(a => !req.url.includes(a))) {
        loaderService.hide();
      }
      throw error;
    }),
    finalize(() => {
      if (apisToBeSkipped.every(a => !req.url.includes(a))) {
        loaderService.hide();
      }
    }),
  );
};
